import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'join',
    pure: true,
    standalone: false
})
export class JoinPipe implements PipeTransform {

    transform(value: string[], separator?: string): string {
        return value.join(separator);
    }

}
